import { getExtensionContext, getService } from 'azure-devops-extension-sdk';
import { CommonServiceIds } from 'azure-devops-extension-api';
import { CoreRestClient } from 'azure-devops-extension-api/Core';

export const getAdminURL = async () => {
  const extensionCtx = getExtensionContext();
  let hostBaseUrl = '/';
  try {
    const locationService = await getService(CommonServiceIds.LocationService);
    hostBaseUrl = await locationService.getResourceAreaLocation(
      CoreRestClient.RESOURCE_AREA_ID
    );
  } catch (error) {
    console.error(
      `It was not possible to retrieve the host URL using the SDK. Defaulting to "/"`,
      error
    );
  }
  return `${hostBaseUrl}_settings/${extensionCtx.id}.retrospectives.admin-hub`;
};
